import { getCompanyValue, getInvestmentValuation, numberWithCommas } from '../gameUtil'
import CrossSvg from '../svgs/CrossSvg'
import LeaderBoardBgSvg from '../svgs/LeaderBoardBgSvg'

function sortData(data,turn){
        let array = data?.participations?.sort((a,b)=>{
            return   (getCompanyValue(b,turn)||0) - (getCompanyValue(a,turn)||0)
        })
        return array
}

export default function Component(props){

    const data= props.data
    const turn = data.game?.[0]?.turn%2===1? ( data.game?.[0]?.turn) : (data.game?.[0]?.turn-1)


    return(
        <div className='myblur' style={{position:'absolute',top:0,left:props.showLeaderBoard?0:"-200%",width:'100%',height:'100%',backgroundColor: 'rgba(0, 0, 0, 0.20)',backdropFilter:'blur(10px)',transition:'.2s all ease',opacity:props.isLeaderBoard?1:0,overflow:'hidden',zIndex:5}}>
            <div style={{display:'flex',flexDirection:'column',position:'absolute',left:props.isLeaderBoard?0:'-200%',top:0,width:'100%',height:'100%',transition:'.5s all ease',justifyContent:'center',alignItems:'center',gap:'1%'}}>
                <div style={{position:'absolute',backgroundColor:"transparent"}}>
                    <LeaderBoardBgSvg width='min( 90svh/ 1080 * 1920, 90svw)' isHideTitle={true}/>
                </div>
                <div style={{position:'absolute',top:'11%',left:'15%',fontSize:'min( 1.5svh/ 1080 * 1920, 1.5svw)',color:"white",fontWeight:'700'}}>
                    Company Information
                </div>
                <div style={{position:'absolute',width:'82%',height:'70%',top:'20%',overflowY:'auto',display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'center'}}>
                    <div style={{width:'100%',display:"flex",justifyContent:'space-between',alignItems:'center',fontSize:'min( .9svh/ 1080 * 1920, .9svw)',fontWeight:'700',borderBottom:'2px solid black',paddingBottom:'min(1svh/ 1080 * 1920, 1svw)'}}>
                        <div style={{flex:1,color:"#007D98"}}>Rank</div>
                        <div style={{flex:3}}>Company</div>
                        <div style={{flex:3}}>Total Company Value (mil)</div>

                    
                    </div>
                    {sortData(data,turn).map((item,index)=>
                        <div key={index} style={{width:'100%',display:"flex",justifyContent:'space-between',alignItems:'center',fontSize:'min( 1svh/ 1080 * 1920, 1svw)',fontWeight:'400',borderBottom:'1px solid #00C9D6',padding:'min(.6svh/ 1080 * 1920, .6svw) 0px',minHeight:"min(3svh/ 1080 * 1920, 3svw)"}}>
                            <div style={{flex:1,color:"#007D98"}}>{Number(index)+1}</div>
                            <div style={{flex:3}}>{item?.participant?.username} Co.</div>
                           
                            <div style={{flex:3,fontWeight:900,color:'rgb(24,191,204)',fontSize:'min(1.2svh/ 1080 * 1920, 1.2svw)'}}>{numberWithCommas( ((Math.round((getCompanyValue(item,turn))))||0) )}</div>  
                        </div>
                    )}
                </div>



            </div>
            <div onClick={()=>{props.setisLeaderBoard(null);setTimeout(()=>{props.setshowLeaderBoard(null)},200)}} style={{position:'absolute',right:'2%',top:'2%'}}>
                <CrossSvg width={`min( 7svh/ 1080 * 1920, 7svw)`}/>
            </div>
        </div>
    )
}

